import * as React from "react";
import { hashHistory } from "react-router";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import { Opportunity } from "../../models/opportunity";
import { IContactUsLocalization } from "../../models/localization";
import { SavedOpportunity } from "../../models/profile";
import { Grid, Row, Col } from "react-flexbox-grid";
import FAQViewer from "../../components/help/faqs";
import Contact from "../../components/help/contact";
import BackButton from "../../components/widgets/backBtn";
import * as s from "./help.css";

@inject("store") @observer
export default class HelpVw extends React.Component<{ store: SeekerStore }, {}> {
    constructor(props: any) {
        super(props);
    }

    componentWillMount(): void {
        this.props.store.legal.hideTermsAndConditions();
        this.props.store.legal.hidePrivacyStatement();
    }
    render(): JSX.Element {
        const local: IContactUsLocalization = this.props.store.localization.fields.contactUs;
        return (
          <div>
            <BackButton />
            <Grid>
              <Row className={s.row}>
                    <Col xs={12} sm={5} className={s.col1}>
                        <div className={s.formContainer}>
                            <Col xs={12}><h4 className={s.blueHeader}>{local.helpTitle}</h4></Col>
                            <Col xs={12}><h6 className={s.greyHeader}>{local.helpSubtitle}</h6></Col>
                            <Col xs={12}><Contact store={this.props.store} /></Col>
                        </div>
                    </Col>

                    <Col xs={12} sm={7} className={s.col2}>
                        <Col xs={12}><h4 className={s.blueHeader}>{local.faqTitle}</h4></Col>
                        <Col xs={12}><h6 className={s.greyHeader}>{local.faqSubtitle}</h6></Col>
                        <Col xs={12}><FAQViewer store={this.props.store} /></Col>
                    </Col>
                </Row>
            </Grid>
          </div>);
    }
}


// WEBPACK FOOTER //
// ./src/views/help/index.tsx